export const reprocessModalText =
  "Where would you like to reprocess this transaction?";
export const reprocessModalOtherText = "Select an option";
export const reprocessToMcashText =
  "Do you want to proceed with reprocessing these transactions to MCash?";
export const reprocessToBranchText =
  "Do you want to proceed with reprocessing these transactions to Branch?";

export const forgetPasswordConfirmationText =
  "A confirmation email has been sent to your email address. Please check your inbox (and spam folder) for further instructions.";
